/*
 * @Author: Chao Yang
 * @Date: 2019-09-30 01:58:26
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-05-29 03:01:06
 */
export class FooterOption {
  constructor() {
    this.branding = '';
    this.copyRight = "2008 - [[year]] Alter Domus (US) LLC (\"Alter Domus\")";
    this.email = 'CorProSupport@alterDomus.com';
    this.phone = '+1 312-262-3200';
    this.opertionTime = "8am – 5pm CST";
    this.homeSite = 'https://www.alterdomus.com/';
    this.privacyShieldNotice = 'https://www.alterdomus.com/privacy-notice';
  }
  public branding: string;
  public email: string;
  public homeSite: string;
  public phone: string;
  public privacyShieldNotice: string;
  public footerHtml: string;
  public opertionTime: string;
  public copyRight: string;
}
